module.exports = __webpack_public_path__ + "img/20200313120215465.95820ff9.png";